import React from 'react';
import { connect } from 'react-redux';
import { AnyAction, bindActionCreators, Dispatch } from 'redux';
import { modalsActionsClose, modalsActionsOpen } from '../../store/modules/ModalsActions';
import { ModalsActionTypes } from '../../store/modules/ModalsActionTypes';
import { IModalProps } from '../../store/modules/ModalsReducer';
import PrivateContainer from 'components/PrivateContainer/PrivateContainer';
import TelaInicialAssociado from 'components/TelaInicialAssociado/TelaInicialAssociado';
import TelaInicialAssessor from 'pages/Assessor/Home';
import { IAuthUserReducer } from 'store/modules/AuthReducer';
import { IReducer } from 'store/Reducer';
import { isAssessorProfile } from 'utils/AuthUtils';


export interface IPrivateMain {
  usuario?: IAuthUserReducer,
  modalsActionsOpen: (component: React.ElementType, componentProps: IModalProps, key?: string) => ModalsActionTypes,
  modalsActionsClose: (key: string) => ModalsActionTypes,
}

export interface IPrivateMainState {
  modalKey: string
}

class PrivateMain extends React.Component<IPrivateMain, IPrivateMainState> {

  render() {
    return (
      <PrivateContainer>
        {
          this.props.usuario && isAssessorProfile(this.props.usuario.perfil) ? (
            <TelaInicialAssessor />
          ) : (
            <TelaInicialAssociado />
          )
        }
      </PrivateContainer>
    );
  }
}

const mapStateToProps = (state:IReducer) => {
  return {
    usuario: state.auth.usuario
  };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => bindActionCreators({
  modalsActionsOpen,
  modalsActionsClose
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PrivateMain);